export type RedactToken = { text: string; sensitive: boolean; conceptId: string };
export type RedactRound = { context: string; tokens: RedactToken[] };

const S = "self_hosted";
const P = "privacy_first";
const Y = "your_content";

export const NOTANY_REDACT_DECK: readonly RedactRound[] = [
  {
    context: "A draft you’re about to paste into a public AI tool. Redact what should not leave:",
    tokens: [
      { text: "Please summarize this account", sensitive: false, conceptId: S },
      { text: "for customer Jane Okafor", sensitive: true, conceptId: P },
      { text: "account 4471-8820", sensitive: true, conceptId: P },
      { text: "and our unreleased Q3 roadmap", sensitive: true, conceptId: S },
      { text: "into three bullet points.", sensitive: false, conceptId: S },
    ],
  },
  {
    context: "Lesson surfaced after the round — with notanyai self-hosted, this is moot:",
    tokens: [
      { text: "Because the model runs in your own environment,", sensitive: false, conceptId: S },
      { text: "this data never had to leave your perimeter", sensitive: false, conceptId: S },
      { text: "in the first place.", sensitive: false, conceptId: S },
    ],
  },
  {
    context: "Internal note about which training subjects to ship:",
    tokens: [
      { text: "Same engine, our own SubjectPacks:", sensitive: false, conceptId: Y },
      { text: "onboarding, security, compliance.", sensitive: false, conceptId: Y },
      { text: "No content leaves the company.", sensitive: false, conceptId: S },
    ],
  },
  {
    context: "A teammate pastes a support transcript to ‘get help wording a reply’:",
    tokens: [
      { text: "Reply politely to this ticket:", sensitive: false, conceptId: P },
      { text: "user email j.okafor@acme.com", sensitive: true, conceptId: P },
      { text: "home address 742 Evergreen Terrace", sensitive: true, conceptId: P },
      { text: "asking about a refund.", sensitive: false, conceptId: P },
    ],
  },
  {
    context: "Privacy reminder card for the team:",
    tokens: [
      { text: "Deleted accounts are anonymized,", sensitive: false, conceptId: P },
      { text: "not kept identifiable.", sensitive: false, conceptId: P },
      { text: "Row-level security isolates each learner.", sensitive: false, conceptId: P },
    ],
  },
  {
    context: "Message to procurement about hosting:",
    tokens: [
      { text: "The whole stack runs in our own cloud:", sensitive: false, conceptId: S },
      { text: "a static bundle plus an open backend", sensitive: false, conceptId: S },
      { text: "on one small VM.", sensitive: false, conceptId: S },
    ],
  },
];
